import loadable from '@loadable/component';

// 懒加载组件
const OrderManagement = loadable(() => import('./orderManagement/OrderManagement'));

export const subRoutes = [
  {
    // 424001 药品订单查询响应
    path: '/OrderManagement',
    component: OrderManagement
  }
];
